import { useEffect, useContext } from "react";
import { SearchBoxContext } from "../SearchBoxContext/index.js";
const useTrackSearchboxRecentSearchHistory = (openedDestination, hasRecentSearch, isMobile) => {
    const { onTrackSBExperimentStage } = useContext(SearchBoxContext);
    useEffect(() => {
        if (openedDestination) {
            onTrackSBExperimentStage({
                name: "flights_web_cat_searchbox_recent_search_history",
                stage: 1
            });
        }
        if (openedDestination && hasRecentSearch) {
            onTrackSBExperimentStage({
                name: "flights_web_cat_searchbox_recent_search_history",
                stage: 2
            });
            onTrackSBExperimentStage({
                name: "flights_web_cat_searchbox_recent_search_history",
                stage: isMobile ? 4 : 3
            });
        }
    }, [openedDestination, hasRecentSearch, isMobile, onTrackSBExperimentStage]);
};
export default useTrackSearchboxRecentSearchHistory;
